import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import EmptyTypes from 'common/enums/emptyTypes';
import { useAuthLicenseAddOns } from 'common/features/licenseFeatures/useAuthLicenseAddOns';
import {
    fetchMultimediaAction,
    getMultimedia,
    getMultimediaError,
    getMultimediaPending,
} from 'redux/slices/multimediaSlice';
import { getSettings } from 'redux/slices/settingSlice';
import EventFormSelectAssets from './EventFormSelectAssets';
import EventFormSelectAssetsFilter from './EventFormSelectAssetsFilters';

const EventFormSelectMultimedia = (props) => {
    const { selectedMultimedia, close, onConfirm, allowOnlyOneMultimedia = false } = props;
    const { t } = useTranslation();
    const error = useSelector(getMultimediaError);
    const multimedia = useSelector(getMultimedia);
    const pending = useSelector(getMultimediaPending);
    const [name, setName] = useState('');
    const [type, setType] = useState('image');

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            fetchMultimediaAction({
                name,
                page: 1,
                type,
                limit: 1000, // no paginate
            }),
        );
    }, [dispatch, name, type]);

    const settings = useSelector(getSettings);

    const basicMultimedia = useMemo(
        () => [
            {
                value: 'image',
                name: t('multimedia.images'),
            },
            {
                value: 'video',
                name: t('multimedia.videos'),
            },
            {
                value: 'presentation',
                name: t('multimedia.presentations'),
            },
        ],
        [t],
    );

    const [typesSelect, setTypesSelect] = useState(basicMultimedia);

    const isAuthorize = useAuthLicenseAddOns();
    const enableImmersive = isAuthorize(['immersive']);

    useEffect(() => {
        if (settings) {
            setTypesSelect([
                ...basicMultimedia,
                ...(enableImmersive
                    ? [
                          {
                              value: 'immersive',
                              name: t('multimedia.immersive'),
                          },
                      ]
                    : []),
            ]);
        }
    }, [settings, basicMultimedia, enableImmersive, t]);

    const filter = (
        <EventFormSelectAssetsFilter
            type={type}
            setSearch={(n) => setName(n)}
            setType={(tp) => setType(tp)}
            typesSelect={typesSelect}
            searchMinLength={1}
        />
    );

    const assetsForSelect = type !== 'immersive' ? multimedia : multimedia.filter((item) => item.status === 'ready');

    return (
        <EventFormSelectAssets
            search={name}
            emptyType={EmptyTypes.EMPTY_MULTIMEDIA}
            sectionName={t('eventForm.multimedia')}
            filter={filter}
            emptyDescription={t('empty.multimedia')}
            emptyDescriptionNoAssets={t('eventAssets.emptyDescription.multimedia')}
            assets={assetsForSelect}
            error={error}
            pending={pending}
            selectedAssets={selectedMultimedia}
            close={close}
            onConfirm={onConfirm}
            loadMore={() => {}}
            allowOnlyOneMultimedia={allowOnlyOneMultimedia}
        />
    );
};

export default EventFormSelectMultimedia;
